export default __webpack_public_path__ + "static/media/diners.7d22dcc8.svg";